import * as React from "react";
const SvgFiRrH2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12 5v14a1 1 0 1 1-2 0v-6H2v6a1 1 0 1 1-2 0V5a1 1 0 1 1 2 0v6h8V5a1 1 0 1 1 2 0m11 13h-6.882c-.03 0-.074 0-.104-.063a.14.14 0 0 1 .025-.155c.553-.652 1.562-1.288 2.631-1.961 2.441-1.536 5.479-3.449 5.324-7.095C23.882 6.076 21.688 4 19 4c-2.757 0-5 2.243-5 5a1 1 0 1 0 2 0c0-1.654 1.346-3 3-3 1.586 0 2.93 1.261 2.996 2.81.105 2.487-2.181 3.927-4.392 5.318-1.203.758-2.339 1.473-3.092 2.36a2.13 2.13 0 0 0-.313 2.29A2.09 2.09 0 0 0 16.117 20h6.882A1 1 0 0 0 23 18"
    />
  </svg>
);
export default SvgFiRrH2;
